import { ChildrenProps } from "types";

export function Container({ children }: ChildrenProps) {
  return (
    <table className="w-full">
      <tbody>{children}</tbody>
    </table>
  );
}
export function Item({ children }: ChildrenProps) {
  return <tr className="border-b border-[#ECEFF2]">{children}</tr>;
}
export function Title({ children }: ChildrenProps) {
  return (
    <td className="w-1/2 align-top py-3 text-sm font-normal text-[#5E6278]">
      {children}
    </td>
  );
}
export function Value({ children }: ChildrenProps) {
  return (
    <td className="w-1/2 align-top py-3 text-sm font-normal text-[#3D3F4E]">
      {children}
    </td>
  );
}
